import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { TuneTrigger } from "@/components/TunePanel";

function weatherDescription(code: number): string {
  if (code === 0) return "skyfrit";
  if (code <= 3) return "let sol";
  if (code <= 48) return "tåge";
  if (code <= 55) return "støvregn";
  if (code <= 67) return "regn";
  if (code <= 77) return "sne";
  if (code <= 82) return "byger";
  if (code <= 86) return "snebyger";
  if (code <= 99) return "torden";
  return "";
}

function getIsoWeek(d: Date): number {
  const tmp = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = tmp.getUTCDay() || 7;
  tmp.setUTCDate(tmp.getUTCDate() + 4 - day);
  const yearStart = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 1));
  return Math.ceil((((tmp.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
}

/**
 * Edition-linje: venstre = uge-nummer + vejr (rolig, ikke datapunkt),
 * midte = kursiv tagline i sepia, højre = Min samling + Tilpas.
 */
export function EditionBar() {
  const [uge, setUge] = useState<string>("");
  const [weather, setWeather] = useState<{ temp: number; desc: string } | null>(null);

  useEffect(() => {
    const now = new Date();
    setUge(`Uge ${getIsoWeek(now)}`);
    fetch(
      "https://api.open-meteo.com/v1/forecast?latitude=55.6761&longitude=12.5683&current_weather=true&timezone=Europe/Copenhagen",
    )
      .then((r) => r.json())
      .then((data) => {
        if (data.current_weather) {
          setWeather({
            temp: Math.round(data.current_weather.temperature),
            desc: weatherDescription(data.current_weather.weathercode),
          });
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div className="content-canvas">
      <div className="flex flex-wrap items-center justify-between gap-y-2 gap-x-4 py-4 md:py-[18px] font-serif text-[11px] md:text-[12px] font-medium tracking-[0.14em] uppercase text-muted">
        <span className="inline-flex items-center gap-2">
          <span className="text-ink">{uge || "…"}</span>
          {weather && (
            <>
              <span aria-hidden="true" className="text-rule">·</span>
              <span
                aria-hidden="true"
                className="inline-block w-[7px] h-[7px] rounded-full bg-sun shrink-0"
              />
              <span>
                {weather.temp}°<span className="hidden sm:inline"> · {weather.desc}</span>
              </span>
            </>
          )}
        </span>
        <span className="hidden md:inline text-[15px] italic tracking-[0.06em] normal-case text-accent">
          langsomt liv, dagligt kurateret
        </span>
        <span className="inline-flex items-center gap-4 md:gap-[18px]">
          <Link
            to="/bogmaerker"
            className="hover:text-ink transition-colors"
          >
            Min samling
          </Link>
          <TuneTrigger />
        </span>
      </div>
    </div>
  );
}
